import {createStore} from "vuex";

const store = createStore({
    state () {
        return {
            faculdade: null,
            id: 0,
            faculdadename: "",
            language: "pt"
        }
    },
    mutations: {
        setFaculdadeID(state,id){
            state.id = id;
        },
        setFaculdade(state,faculdade){
            state.faculdade = faculdade;
        },
        setFaculdadeName(state,name){
            state.faculdadename = name;
        },
        setLanguage(state,lang){
            state.language = lang
        }
    }
});

export default store;